import theme from '@/common/theme';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Styled from './sales-flow-breadcrumb-style';

/**
 * BreadCrumb component displays a navigational breadcrumb for product section.
 * @param { object } props - steps object
 * @returns {JSX.Element} - The returned jsx element
 */
const ProductSelectionBreadcrumb = ({ steps, activeIndex, setActiveIndex }) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <Styled.Container>
      {steps?.map((step) => {
        const { index, label } = step;
        const isActiveStep = activeIndex === index;
        const isCompletedStep = index < activeIndex;
        const isSelectableStep = isActiveStep || isCompletedStep || index === 0;

        let color = theme.COLOR_GREY4;
        if (isActiveStep) {
          color = theme.COLOR_PRIMARY;
        } else if (isCompletedStep) {
          color = theme.COLOR_BLACK;
        }

        return (
          <React.Fragment key={`${step.route}___${index + 1}`}>
            <Styled.StyledLink
              onClick={() => {
                if (isSelectableStep) {
                  setActiveIndex(index);
                  navigate(step.navigation, { state });
                }
              }}
              color={color}
              disabled={!isSelectableStep}
            >
              {label}

              {index >= 0 && index !== steps.length - 1 && (
                <Styled.StyledChevronRightIcon />
              )}
            </Styled.StyledLink>
          </React.Fragment>
        );
      })}
    </Styled.Container>
  );
};

ProductSelectionBreadcrumb.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      index: PropTypes.number,
      key: PropTypes.string,
      element: PropTypes.string,
    }),
  ).isRequired,
  activeIndex: PropTypes.number.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
};

export default ProductSelectionBreadcrumb;
